<template>
  <footer>
    <span>Follow Us</span>
    <div class="socials">
      <!-- 占位链接（暂无跳转目标）：prevent 掉默认行为，避免把 # 写进 history URL -->
      <a href="#" aria-label="Instagram" @click.prevent>Ins</a>
      <a href="#" aria-label="Facebook" @click.prevent>Fb</a>
      <a href="#" aria-label="Twitter" @click.prevent>Tw</a>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'MyFoot'
}
</script>

<style scoped>
footer{
  display:flex;
  justify-content:flex-end;
  align-items:center;
  gap:0.625rem;
  margin-top:1.25rem;
}
footer span{
  font-size:0.75rem;
  color:var(--dark-brown);
  font-weight:600;
}
.socials{
  display:flex;
  gap:0.5rem;
}
.socials a{
  width:22px;
  height:22px;
  border-radius:50%;
  background:#558b2f;
  display:flex;
  align-items:center;
  justify-content:center;
  color:#fff;
  font-size:0.625rem;
  text-decoration:none;
}
</style>
